import React, { useState, useEffect, useRef } from 'react';

const LiveStreamPage = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showVideo, setShowVideo] = useState(false);
  const videoContainerRef = useRef(null);
  
  // Images to display in slideshow when not live
  const slideContent = [
    { type: 'image', url: 'https://customer-assets.emergentagent.com/job_frosty-it-hub/artifacts/5zdhhiuu_7a468335-0926-436c-b2f2-9b07999faab0.png' },
    { type: 'image', url: 'https://customer-assets.emergentagent.com/job_frosty-it-hub/artifacts/ej6kcw4w_502631291_1129413465893708_1502759487214480633_n.jpg' },
    { type: 'image', url: 'https://customer-assets.emergentagent.com/job_frosty-it-hub/artifacts/v2v60pzs_504915314_1129413565893698_4586770220882747964_n.jpg' },
    { type: 'image', url: 'https://customer-assets.emergentagent.com/job_frosty-it-hub/artifacts/ja766bvk_505651570_1129413422560379_7617166342520832721_n.jpg' },
    { type: 'image', url: 'https://customer-assets.emergentagent.com/job_frosty-it-hub/artifacts/8jlaviuf_2.jpg' },
    { type: 'image', url: 'https://customer-assets.emergentagent.com/job_frosty-it-hub/artifacts/8vgywoud_267797639_10158969015068823_2039859151906051438_n.png' },
    { type: 'image', url: 'https://customer-assets.emergentagent.com/job_frosty-it-hub/artifacts/4qul11v6_502631291_1129413465893708_1502759487214480633_n.jpg' },
    { type: 'image', url: 'https://customer-assets.emergentagent.com/job_frosty-it-hub/artifacts/jt39kuem_505794842_1129413352560386_7704085084575454587_n.jpg' },
    { type: 'image', url: 'https://customer-assets.emergentagent.com/job_frosty-it-hub/artifacts/90eo09ax_505900926_1129413575893697_2970417087136259988_n.jpg' },
    { type: 'image', url: 'https://customer-assets.emergentagent.com/job_frosty-it-hub/artifacts/8bdyr38m_519610920_1163224462512608_2008666275131166416_n.jpg' },
  ];
  
  // Embed URL for St. Paul's Perham live stream - auto-detects current live stream
  const embedUrl = 'https://www.youtube.com/embed/live_stream?channel=UCnm9vJzC0_xQtfXSVCXpyug&autoplay=1&mute=1';
  
  // Auto-advance slideshow every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      if (!showVideo) {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % slideContent.length);
      }
    }, 5000);
    
    return () => clearInterval(interval);
  }, [slideContent.length, showVideo]);
  
  // Handle going fullscreen
  const handleWatchLive = () => {
    setShowVideo(true);
    
    // Request fullscreen
    setTimeout(() => {
      if (videoContainerRef.current) {
        if (videoContainerRef.current.requestFullscreen) {
          videoContainerRef.current.requestFullscreen().catch(err => {
            console.log('Fullscreen request failed:', err);
          });
        } else if (videoContainerRef.current.webkitRequestFullscreen) {
          videoContainerRef.current.webkitRequestFullscreen();
        } else if (videoContainerRef.current.mozRequestFullScreen) {
          videoContainerRef.current.mozRequestFullScreen();
        } else if (videoContainerRef.current.msRequestFullscreen) {
          videoContainerRef.current.msRequestFullscreen();
        }
      }
    }, 100);
  };
  
  // Handle exiting fullscreen
  const handleBackToSlideshow = () => {
    setShowVideo(false);
    
    // Exit fullscreen
    if (document.exitFullscreen) {
      document.exitFullscreen().catch(err => console.log('Exit fullscreen failed:', err));
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  };
  
  // Listen for fullscreen changes
  useEffect(() => {
    const handleFullscreenChange = () => {
      const isFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );
      
      // If exiting fullscreen, go back to slideshow
      if (!isFullscreen && showVideo) {
        setShowVideo(false);
      }
    };
    
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', handleFullscreenChange);
    
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
    };
  }, [showVideo]);
  
  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <div className="w-full max-w-7xl">
        {/* YouTube Live Stream with Slideshow Overlay */}
        <div 
          ref={videoContainerRef}
          className="relative bg-black rounded-lg overflow-hidden shadow-2xl" 
          style={{ paddingBottom: '56.25%', height: 0 }}
        >
          {/* YouTube Embed (always loaded in background) */}
          <iframe
            src={embedUrl}
            title="St. Paul's Perham Live Stream"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className="absolute top-0 left-0 w-full h-full z-0"
            style={{ border: 'none' }}
          />
          
          {/* Slideshow Overlay (shows in front when not clicked) */}
          {!showVideo && (
            <div 
              className="absolute inset-0 z-20 cursor-pointer"
              onClick={handleWatchLive}
            >
              {slideContent.map((content, index) => (
                <div
                  key={index}
                  className={`absolute inset-0 transition-opacity duration-1000 ${
                    index === currentImageIndex ? 'opacity-100' : 'opacity-0'
                  }`}
                >
                  {content.type === 'image' ? (
                    <img
                      src={content.url}
                      alt={`St. Paul's Lutheran Church ${index + 1}`}
                      className="w-full h-full object-contain"
                    />
                  ) : (
                    <iframe
                      src={content.url}
                      title={`Church Video ${index + 1}`}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      className="w-full h-full"
                      style={{ border: 'none', pointerEvents: 'none' }}
                    />
                  )}
                </div>
              ))}
            </div>
          )}
          
          {/* Back to Slideshow Button (when video is showing) */}
          {showVideo && (
            <button
              onClick={handleBackToSlideshow}
              className="absolute top-4 right-4 z-30 bg-slate-900/80 hover:bg-slate-800 text-white px-4 py-2 rounded-lg transition-all duration-300"
            >
              ← Back to Slideshow
            </button>
          )}
        </div>
        
        {/* Info Text */}
        <div className="text-center mt-8 space-y-4">
          <p className="text-slate-300 text-xl">
            Streaming St. Paul's Lutheran Church & School
          </p>
          <p className="text-slate-500 text-sm">
            {showVideo 
              ? 'Stream playing in fullscreen mode'
              : 'Click the slideshow to watch the live stream when available'
            }
          </p>
          <a
            href="https://www.youtube.com/@stpaulsperham"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block text-cyan-400 hover:text-cyan-300 transition-colors text-lg"
          >
            Visit YouTube Channel →
          </a>
        </div>
      </div>
    </div>
  );
};

export default LiveStreamPage;
